module.exports = __webpack_public_path__ + "media/images/solo-150-new@2x-4cc39331c6a5e27a55c9265cd6d5e480.webp";